import { render, staticRenderFns } from "./Metatag.vue?vue&type=template&id=f075d044&"
import script from "./Metatag.vue?vue&type=script&lang=js&"
export * from "./Metatag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports